/**
** this create sub nav effect
**/
import $ from 'jquery';

export const subNav = () => {

	//U2shop Dropdown toggle function
	$('#menuItem-u2shop').click(function () {
		$(this).next('.shop').slideToggle("fast");
	});

	//Hide dropdown on page click
	//this function is so inifficient. It gets called in each and every click event in the website. This isn't the way we should handle this
	$(document).on('click', function (e) {
		if (!$("#menuItem-u2shop").is(e.target) && !$("#menuItem-u2shop").has(e.target).length) {
			$('.shop').slideUp("fast");
		}
	});	

}

